<template>
  <div class="flex">
    <template v-if="loading">
      <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    </template>
    <template v-else>
      <div class="left_task_part">
        <p>Задача: <strong>{{ task.id }}</strong></p>
        <p class="text-muted">{{ printDate(task.created_at) }}</p>
        <v-popover
          v-if="(task.users ?? []).length"
          class="d-inline"
          placement="bottom"
          :auto-hide="true"
        >
          <span class="badge badge-info pointer">Пользователи</span>
          <template slot="popover">
            <div>
              <div v-for="u in task.users">
                ({{ u.user_id }})
                <UserName :id="u.user_id"/>
              </div>
            </div>
          </template>
        </v-popover>
        <!--                          <template v-if="[3,4,7,9].includes(task.type_id)">-->
        <template v-if="task.order_id && ![19].includes(task.type_id)">
          <p class="flex align-items-centers">Заявка: <strong>{{ task.order_id }}</strong>
            <button @click="orderToEdit(task.order_id)" class="btn btn-xs btn-info ml-1 mr-1">
              <i class="icon-fa icon-fa-eye"></i>
            </button>
            <PrePaidButton v-if="allowToEditPrePaid" :order="{id: task.order_id}"/>
          </p>
          <div v-for="p in task.order.order_phones" class="mb-2">
            <a :href="`tel:+${p.phone.phone}`">{{ p.phone.phone }}</a>
          </div>
          <p><strong>{{ mixinGetCityNameByOrder(task.order) }}</strong></p>
          <p><strong>{{ task.order.project_label }}</strong> <span v-html="printOrderStatus(task.order)"/>
          </p>
        </template>
        <template v-if="task.type_id === 3">
          <p>Ставка: <strong>{{ orderSalaryRates[task.task_data.old_value] }}</strong></p>
          <p>Запрос: <strong>{{ orderSalaryRates[task.task_data.new_value] }}</strong></p>
        </template>
        <div class="mt-2"
             v-if="[3,4,6, 26, 33].includes(task.type_id) || task.created_by === $currentUID || allowToCloseByDate(task.created_at)">
          <LoadingButton
            title="Закрыть задачу"
            :loading="btnLoading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => closeTask(task, true)"
            className="btn btn-outline-success"
          />
        </div>
      </div>
      <div class="flex-grow-1">
        <template v-if="task.dialog">
          <Messages
            :hideNames="hideNames"
            :acceptTask="() => acceptTask(task.id)"
            :dialogId="task.dialog.id"
            :dialogAccepted="task.created_by === $currentUID || task.dialog.is_accepted"
            :messages="task.dialog.messages"
            :updateDialog="(u) => task.dialog = {...task.dialog, ...u}"
          />
        </template>
        <template v-else>
          <template v-if="task.type_id === 33">
            <h4>Запрос клиента на обратный звонок</h4>
            <p v-if="task.task_data?.task_data">{{ task.task_data.task_data }}</p>
          </template>
          <template v-if="task.type_id === 24">
            <AddSupplierCodes :task="task" :updateTasks="() => getAllTasks(true)"/>
          </template>

          <template v-if="task.type_id === 31">
            <DisabledDrugsList :drugs="task.task_data?.drugs"/>
          </template>

          <template v-if="task.type_id === 22">
            <ManufacturerDrugInfoTask
              :task="task"
              :updateTasks="() => getAllTasks(true)"
              :updateTasksPull="() =>getAllTasks(true)"
            />
          </template>

          <template v-if="[23,26].includes(task.type_id)">
            <SimpleTaskWithComment
              :showTaskInfo="true"
              :task="task"
              :updateTasks="() => getAllTasks(true)"/>
          </template>

          <template v-if="task.type_id === groups?.sendOrderByPost?.type">
            send post
          </template>

          <template v-if="task.type_id === groups?.diffPrices?.type">
            <DiffPriceNoCashPrice
              :order="task.order"
            />

            <div class="text-right">
              <LoadingButton
                title="Закрыть задачу"
                :loading="btnLoading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => closeTask(task)"
                className="btn btn-outline-success"
              />
            </div>

          </template>

          <template v-if="task.type_id === groups?.orderByCashWSms?.type">
            <CashOrderWithSMS
              :order="task.order"
            />

            <div class="text-right">
              <LoadingButton
                title="Закрыть задачу"
                :loading="btnLoading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => closeTask(task)"
                className="btn btn-outline-success"
              />
            </div>

          </template>

          <template v-if="task.type_id === 27">
            <PairDrug ref="pairDrug"
                      :drug="task.related_ms_drug"
                      :pairedDrugs="task.related_ms_drug.related_drugs"/>
          </template>

          <template v-if="task.type_id === 14">
            <DrugInInvoice
              :drug="task.drug"
              :invoice="{id: task.object_id}"
              :taskData="task.task_data"
            />
          </template>

        </template>
      </div>
    </template>

  </div>
</template>

<script>
import DisabledDrugsList from "@/views/tasks/components/DisabledDrugsList.vue";
import ManufacturerDrugInfoTask from "@/views/tasks/types/ManufacturerDrugInfoTask.vue";
import CashOrderWithSMS from "@/views/tasks/components/CashOrderWithSMS.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DiffPriceNoCashPrice from "@/views/tasks/components/DiffPriceNoCashPrice.vue";
import PrePaidButton from "@/components/orders/prePaid/PrePaidButton.vue";
import PairDrug from "@/views/statistics/components/tasksType/PairDrug.vue";
import UserName from "@/components/users/UserName.vue";
import SimpleTaskWithComment from "@/views/tasks/components/SimpleTaskWithComment.vue";
import DrugInInvoice from "@/views/tasks/components/DrugInInvoice.vue";
import AddSupplierCodes from "@/views/tasks/components/AddSupplierCodes.vue";
import Messages from "@/components/chat/components/Messages.vue";
import moment from "moment";
import api from "@/api";

export default {
  components: {
    LoadingButton,
    ManufacturerDrugInfoTask,
    DisabledDrugsList,
    CashOrderWithSMS,
    DiffPriceNoCashPrice,
    PrePaidButton,
    PairDrug,
    UserName,
    SimpleTaskWithComment,
    DrugInInvoice,
    AddSupplierCodes,
    Messages,
  },
  props: ['task', 'taskId', 'updateTask', 'getAllTasks', 'groups', 'currentTask'],
  data() {
    return {
      allowToEditPrePaid: false,
      loading: false,
      hideNames: true,
      btnLoading: false,
      orderSalaryRates: {
        0: 'низкая ставка',
        1: 'высокая ставка',
        2: 'дальняя ставка',
      },
    }
  },
  async created() {
    if (!this.task?.id) {
      await this.getTask();
    }
    if (this.$currentUserRoles.includes('supervisor')
      || this.$currentUserRoles.includes('manager')
      || this.$currentUserRoles.includes('managerAssist')
      || this.$currentRole === 'admin'
    ) {
      this.hideNames = false;
      this.allowToEditPrePaid = true;
    }
    // this.getAllTasks();
  },
  methods: {
    async getTask() {
      this.loading = true;
      const {data} = await api.index('/tasks/' + this.taskId);
      if (this.updateTask) {
        this.updateTask(data.task);
      }
      this.loading = false;
    },
    orderToEdit(id, dialog = null) {
      if (this.$currentUserRoles.includes('chiefRunner') || this.$currentUserRoles.includes('runner')) {
        this.$store.dispatch('platform/setGlobalDrawerData', {
          data: {type: 'orderDetailsForRunner', orderId: id}
        });
      } else {
        this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
      }
      // this.$store.dispatch('orders/setOrderToEdit', {orderId: id, dialog: {...dialog, messages: this.activeMessages}});
    },
    allowToCloseByDate(date) {
      const compareDate = moment().subtract(5, 'days');
      return moment(date) < compareDate;
    },
    async closeTask(task, silent = false) {
      this.btnLoading = true;

      const validation = this.allowToCloseTask(task.id);
      if (!validation.success) {
        toastr['warning'](validation.message ?? 'Недостаточно данных для закрытия задачи');
        this.btnLoading = false;
        return;
      }

      const {data} = await api.post('/tasks/' + task.id, {
        action: 'closeTask',
      })
      if (data.success) {
        toastr['success']('Задача сохранена', 'Успешно');
        if (this.getAllTasks) await this.getAllTasks(true);
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading = false;
    },
    allowToCloseTask(taskId) {
      let message = null;
      let pass = true;
      // const task = (this.allTasks ?? []).find((t) => t.id === +taskId);
      // if (!task) message = 'Задача не найдена';
      const task = {...this.task};
      switch (+task.type_id) {
        case 22:
          if (!task.manufacturer_id) {
            pass = false;
            message = 'Нет поставщика в задаче';
          }
          break;
      }
      return {success: pass, message};
    },
    async acceptTask(id) {
      const {data} = await api.post('/tasks/' + id, {
        action: 'acceptTask',
      })
      if (data.success) {
        toastr['success']('Задача принята', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
    },
  }
}

</script>
